import voca from 'voca';
export const processData = (data, rowObj) => {
  const bodyData = data.map((row) => {
    if (row.id === rowObj.id) {
      return {
        ...row,
        key: voca.trim(rowObj.key),
        value: rowObj.value,
      };
    }
    return row;
  });

  if (data[data.length - 1].id === rowObj.id) {
    const newId = rowObj.id + 1;
    const newRow = { id: newId, key: '', value: '' };
    return [...bodyData, newRow];
  }
  return bodyData;
};
export const processErrorData = (data, rowObj) => {
  const bodyData = data.map((row) => {
    if (row.id === rowObj.id) {
      return {
        ...row,
        path: voca.trim(rowObj.path),
        value: voca.trim(rowObj.value),
        message: voca.trim(rowObj.message),
      };
    }

    return row;
  });

  if (data[data.length - 1].id === rowObj.id) {
    const newId = rowObj.id + 1;
    const newRow = { id: newId, path: '', value: '', message: '' };
    return [...bodyData, newRow];
  }

  return bodyData;
};

export const getFilteredArray = (array) => {
  let filterArr = [];
  for (let i = 0; i < array.length; i++) {
    if (array[i].key && array[i].key != '' && array[i].value && array[i].value != '') {
      filterArr.push(array[i]);
    }
  }
  filterArr = correctOrderOfArray(filterArr);
  return filterArr;
};

const correctOrderOfArray = (array) => {
  return array.map((item, index) => ({
    ...item,
    id: index,
  }));
};

export const getFilteredErrorArray = (array) => {
  let filterArr = [];
  for (let i = 0; i < array.length; i++) {
    if (
      array[i].path &&
      array[i].path != '' &&
      array[i].value &&
      array[i].value != '' &&
      array[i].message &&
      array[i].message != ''
    ) {
      filterArr.push(array[i]);
    }
  }
  return filterArr;
};
export const processMapping = (collectionMapping) => {
  const collectionMappingArray = getFilteredArray(collectionMapping);
  let collectionMappingObject = [];
  collectionMappingArray.forEach((e) => {
    let selectedValue =
      e.value && typeof e.value === 'string' && e.value.includes('{') ? JSON.parse(e.value) : {};
    collectionMappingObject.push({
      key: e.key,
      value: selectedValue.name,
      type: selectedValue.type,
    });
  });
  return collectionMappingObject;
};

export const checkAndCompareValue = (input1, input2) => {
  return Array.isArray(input2)
    ? arraysEqual(
        input1,
        input2.map((key) => key.value),
      )
    : input1 === input2.value;
};

export const checkAndExtractValue = (input, isReturnArray) => {
  if (!input) return '';
  return Array.isArray(input)
    ? input.map((key) => key.value)
    : isReturnArray
    ? [input.value]
    : input.value;
};

export const arraysEqual = (a, b) => {
  if (a instanceof Array && b instanceof Array) {
    if (a.length != b.length) return false;
    for (
      var i = 0;
      i < a.length;
      i++ // assert each element equal
    )
      if (!arraysEqual(a[i], b[i])) return false;
    return true;
  } else {
    return a == b; // if not both arrays, should be the same
  }
};

export const populateTimeout = (responseDataMapping, timeout) => {
  if (timeout && Object.keys(timeout).length > 0) {
    return timeout;
  }

  const { timeoutLimit, timeoutMsg } = responseDataMapping;
  let newTimeout = {};
  if (timeoutLimit) {
    newTimeout.limit = timeoutLimit;
  }
  if (timeoutMsg) {
    newTimeout.message = timeoutMsg;
  }
  return newTimeout;
};

export const populateError = (responseDataMapping, errors) => {
  const { errorPath, errorValue, errorMsgPath } = responseDataMapping;
  if (errors && errors.length > 0) {
    errors = errors.map((error, index) => ({ ...error, id: index + 1 }));
    return errors;
  }
  const error = { id: 1 };
  if (errorPath) {
    error.path = errorPath;
  }
  if (errorValue) {
    error.value = errorValue;
  }
  if (errorMsgPath) {
    error.message = errorMsgPath;
  }
  return [error];
};

export const parseJsonString = (str) => {
  try {
    str = str
      .replace(/\\n/g, '\\n')
      .replace(/\\'/g, "\\'")
      .replace(/\\"/g, '\\"')
      .replace(/\\&/g, '\\&')
      .replace(/\\r/g, '\\r')
      .replace(/\\t/g, '\\t')
      .replace(/\\b/g, '\\b')
      .replace(/\\f/g, '\\f');
    // Remove non-printable and other non-valid JSON characters
    // eslint-disable-next-line no-control-regex
    str = str.replace(/[\u0000-\u0019]+/g, '');
    return JSON.parse(str);
  } catch (e) {
    console.log('Error: ', e);
    return {};
  }
};

export const getNeedleListFromJsonObj = (jsonData, jsonObjNeedlelist) => {
  let jsonString = '';
  if (jsonData && jsonData.includes("'")) {
    jsonString = jsonData.replaceAll("'", '"');
    jsonString = JSON.stringify(jsonString);
  } else {
    jsonString = JSON.stringify(jsonData);
  }

  let jsonObj = jsonString ? parseJsonString(jsonString) : '';
  jsonObjNeedlelist =
    jsonObj &&
    jsonObj.match(/{{(.*?)}}/g) &&
    jsonObj.match(/{{(.*?)}}/g).map((b) => b.replace(/{{(.*?)}}/g, '$1'));
  return jsonObjNeedlelist;
};

export const getNeedleMapFromJsonObj = (jsonData) => {
  let jsonString = '';
  let jsonObjNeedleKeyMapping = [];
  if (jsonData && jsonData.includes("'")) {
    jsonString = jsonData.replaceAll("'", '"');
    jsonString = JSON.stringify(jsonString);
  } else {
    jsonString = JSON.stringify(jsonData);
  }

  let jsonObj = jsonString ? parseJsonString(jsonString) : '';
  const needleList =
    jsonObj &&
    jsonObj.match(/{{(.*?)}}/g) &&
    jsonObj.match(/{{(.*?)}}/g).map((b) => b.replace(/{{(.*?)}}/g, '$1'));

  needleList &&
    needleList.map((key, index) => {
      const needleKeyObj = { id: ++index, key, value: key };
      jsonObjNeedleKeyMapping.push(needleKeyObj);
    });
  return jsonObjNeedleKeyMapping;
};

export const filterObjectsForRestApi = (originalArray, filterArray) => {
  return originalArray
    .map((obj) => {
      const filteredObject = {};

      Object.entries(obj).forEach(([key, value]) => {
        if (filterArray.includes(key)) {
          filteredObject[key] = value;
        }
      });
      if (Object.keys(filteredObject).length > 0) {
        return filteredObject;
      } else {
        return null;
      }
    })
    .filter((obj) => obj !== null);
};